import React, { PropsWithChildren, useEffect } from "react";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { useThemeColors } from "../../Store/modules/theme";

export const ThemeProvider: React.FC<PropsWithChildren> = (props) => {
  const { children } = props;

  const [theme] = useThemeColors();

  useEffect(() => {
    // Set CSS variable for border color to be used in Tailwind classes
    document.documentElement.style.setProperty("--border-color", theme.border);
  }, [theme.border]);

  return (
    <>
      <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>
    </>
  );
};
